import React, { type ReactElement } from 'react';
import {
  Box,
  type NestedListRowData,
  SkeletonLoader,
} from '@saviynt/design-system';

import './ViolationsTabDetailsConflictsLoader.css';

/**
 * ViolationsTabDetailsConflictsLoader
 */
function ViolationsTabDetailsConflictsLoader(): ReactElement {
  const array = Array.from(Array(3).keys());

  return (
    <Box tag='div' className='Sod-ViolationsTabDetailsConflicts-loaderWrapper'>
      {array.map((ind) => (
        <Box
          key={ind}
          className='Sod-ViolationsTabDetailsConflictsLoader-wrapper'>
          <SkeletonLoader
            shape='square'
            animationStyle='wave'
            width='1.5rem'
            height='1.5rem'
          />
          <SkeletonLoader
            shape='square'
            animationStyle='wave'
            width='1.5rem'
            height='1.5rem'
          />
          <Box
            tag='div'
            className='Sod-ViolationsTabDetailsConflictsLoader-centerContent'>
            <SkeletonLoader
              shape='square'
              animationStyle='wave'
              height='1rem'
              width='75%'
            />
            <SkeletonLoader
              shape='square'
              animationStyle='wave'
              height='2rem'
              width='100%'
            />
          </Box>
          <SkeletonLoader
            shape='square'
            animationStyle='wave'
            height='2.5rem'
            width='7.5rem'
          />
        </Box>
      ))}
    </Box>
  );
}

const ViolationsTabDetailsConflictsNestedLoader = (
  index: number
): NestedListRowData => ({
  id: `${index}-loader`,
  isCheckboxDisabled: true,
  isDisabled: true,
  centerContent: (
    <Box
      tag='div'
      className='Sod-ViolationsTabDetailsConflictsLoader-centerContent'>
      <SkeletonLoader
        shape='square'
        animationStyle='wave'
        height='1rem'
        width='75%'
      />
      <SkeletonLoader
        shape='square'
        animationStyle='wave'
        height='2rem'
        width='100%'
      />
    </Box>
  ),
});

export {
  ViolationsTabDetailsConflictsLoader,
  ViolationsTabDetailsConflictsNestedLoader,
};
